/**
 * Button
 */

// Import extend function.
import Component from '../../js/core/component.js';

class Button extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false
		};
	}

	/**
	 * Initialize component
	 */
    _init () {
    
        this._addButtonClass();

        const observer = new MutationObserver(() => {
			this._addButtonClass();
		});

		observer.observe(document, {
			childList: true,
			subtree: true,  
		});
	}

    _addButtonClass() {
		const linkElements = document.querySelectorAll('.rek-prediction__item .rek-link');

		// Add the class 'c-button' to each selected <a> element
		linkElements.forEach((linkElement) => {
			linkElement.classList.add('c-button');
		});
	}

	addButtonClass() {
		this._addButtonClass();
	}
}

document.addEventListener('newcontent', (e) => {
	// e.target.querySelectorAll('.c-button').forEach((button) => {
	// 	button.button = new Button({
	// 		debug: false
	// 	});
	// });

    e.target.querySelectorAll('.rek-prediction').forEach((button) => {
		button.button = new Button({
			debug: false
		});
	});
    
});

export default Button;


// WEBPACK FOOTER //
// ./components/button/c-button.js